import { render, staticRenderFns } from "./CustomerSubscriptions.vue?vue&type=template&id=24f7f6b5&scoped=true"
import script from "./CustomerSubscriptions.vue?vue&type=script&lang=js"
export * from "./CustomerSubscriptions.vue?vue&type=script&lang=js"
import style0 from "./CustomerSubscriptions.vue?vue&type=style&index=0&id=24f7f6b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f7f6b5",
  null
  
)

export default component.exports